import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    title: "Mosonmagyaróvári Várkiállítás",
    accentColor: '#0F70B7',
    screenNumber: 16,
    language: 'hu',
    keyboard: {
      visible: false,
      value: ''
    }
  },
  mutations: {
    setTitle(state, value) {
      state.title = value;
    },
    setAccentColor(state, value) {
      state.accentColor = value;
    },
    setScreenNumber(state, value) {
      state.screenNumber = value;
    },
    setLanguage(state, value) {
      state.language = value;
    }
  },
  actions: {
  },
  modules: {
  },
  plugins: [createPersistedState()],
});

